var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.973,
    height: 149.999,
    viewBox: "0 0 149.973 149.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42105",
    "data-name": "Group 42105",
    transform: "translate(-175.066 -235.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20921",
    "data-name": "Path 20921",
    d: "M233.3,235.153v16.355c-1.443.088-2.81.227-4.177.233-6.634.025-13.275-.075-19.909.038-10.446.183-17.407,7.031-17.445,17.477q-.161,40.787-.006,81.581c.038,10.641,7.031,17.546,17.741,17.577q40.6.123,81.191,0c10.685-.038,17.54-6.955,17.7-17.628.1-6.634.013-13.274.031-19.909,0-1.266.114-2.526.189-3.982h15.75c.183.214.479.409.479.6-.132,10.131.68,20.387-.668,30.348-2.136,15.763-16.066,27.091-31.948,27.166q-42.158.2-84.316-.006a33.02,33.02,0,0,1-32.761-32.931q-.189-41.959,0-83.919a33.135,33.135,0,0,1,32.73-32.981C216.2,235.058,224.527,235.153,233.3,235.153Z",
    transform: "translate(0)",
    fill: "#fffbf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20922",
    "data-name": "Path 20922",
    d: "M197.977,316.054,186.1,303.794l52.059-51.926H208.492V235.386c1.071-.088,2.186-.246,3.3-.252q22.444-.019,44.883,0c6.729.006,9.854,3.075,9.86,9.728.032,16,.013,31.992.013,48.316h-16.5V263.951Z",
    transform: "translate(58.486 0.019)",
    fill: "#fffbf5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/Forward.e7da39314e03c7fb551d30c8eb547413.svg";
export { ForwardRef as ReactComponent };